"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.export.csv': 'Exportar CSV',
    'reports.export.excel': 'Exportar Excel',
};
